import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [extractionListFilters, setExtractionListFilters] = useState({
    customerId: '',
    rulesetId: '',
    status: ''
  });

  const setExtractionFilters = (filters) => {
    setExtractionListFilters(filters);
  };

  const clearExtractionFilters = () => {
    setExtractionListFilters({
      customerId: '',
      rulesetId: '',
      status: ''
    });
  };

  return (
    <NavigationContext.Provider value={{
      extractionListFilters,
      setExtractionFilters,
      clearExtractionFilters
    }}>
      {children}
    </NavigationContext.Provider>
  );
};